<!-- <app-licence-billing></app-licence-billing> -->
<section class="actions-bar">
    <button mat-raised-button color="accent" class="export-btn" [disabled]="isLoading" (click)="onBilling()">
        {{ 'users.licencesList.billing.shortLabel' | translate }}
    </button>
    <button mat-raised-button color="accent" [disabled]="isLoading" (click)="onExport()">
        <mat-icon aria-label="File">insert_drive_file</mat-icon>
        {{ 'reports.exports.xls.shortLabel' | translate }}
    </button>
    <mat-spinner *ngIf="isLoading" [diameter]="35" color="accent"></mat-spinner>
</section>
<mat-card>
    <mat-card-header>
        <mat-card-title>
            <h2>
                {{'users.licencesList.title.shortLabel' | translate}}
                <app-tooltip [text]="'users.licencesList.title.summary' | translate"></app-tooltip>
            </h2>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <section class="creation-form">
            <button *ngIf="!isCreationMode" (click)="onCreate()"
                [matTooltip]="'users.licencesList.add.summary' | translate" mat-mini-fab class="action-button"
                color="accent">
                <mat-icon aria-label="Add">add</mat-icon>
            </button>
            <app-licence-edit *ngIf="isCreationMode" (editFinished)="onCreateFinished()"></app-licence-edit>
        </section>

        <mat-form-field class="filter-input">
            <mat-label>{{ 'users.licencesList.filter.shortLabel' | translate }}</mat-label>
            <input matInput (keyup)="onApplyFilter($event.target.value)">
        </mat-form-field>

        <table mat-table [dataSource]="dataSource" matSort matSortActive="town" matSortDirection="asc" matSortDisableClear>
            <ng-container matColumnDef="town">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'users.licencesList.town.shortLabel' | translate }} </th>
                <td mat-cell *matCellDef="let licence"> {{ licence.organism.text.shortLabel }} </td>
            </ng-container>

            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'users.licencesList.name.shortLabel' | translate }} </th>
                <td mat-cell *matCellDef="let licence"> {{ licence.text.shortLabel }} </td>
            </ng-container>

            <ng-container matColumnDef="language">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'users.licencesList.language.shortLabel' | translate }} </th>
                <td mat-cell *matCellDef="let licence"> {{ licence.language.codeISO }} </td>
            </ng-container>

            <ng-container matColumnDef="startDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'users.licencesList.startDate.shortLabel' | translate }} </th>
                <td mat-cell *matCellDef="let licence"> {{ licence.startDate | date }} </td>
            </ng-container>

            <ng-container matColumnDef="endDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'users.licencesList.endDate.shortLabel' | translate }} </th>
                <td mat-cell *matCellDef="let licence">
                    <span class="date"
                        [ngClass]="{outdated: endDateOutdated(licence.endDate)}">{{ licence.endDate | date }}</span>
                    <span class="date-outdated-text"
                        *ngIf="endDateOutdated(licence.endDate)">{{ 'users.licencesList.outdated.shortLabel' | translate }}</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="isTerminated">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'users.licencesList.terminated.fullLabel' | translate }} </th>
                <td mat-cell *matCellDef="let licence" class="is-check">
                    <mat-icon aria-label="Checked" [ngClass]="{checked: !!licence.terminationDate}">
                        {{ !!licence.terminationDate ? 'check_box' : 'check_box_outline_blank' }}
                    </mat-icon>
                </td>
            </ng-container>

            <ng-container matColumnDef="isPublic">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'users.licencesList.isPublic.shortLabel' | translate }} </th>
                <td mat-cell *matCellDef="let licence" class="is-check">
                    <mat-icon aria-label="Checked" [ngClass]="{checked: licence.organism.isPublic}">
                        {{ licence.organism.isPublic ? 'check_box' : 'check_box_outline_blank' }}
                    </mat-icon>
                </td>
            </ng-container>

            <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                    {{ 'users.licencesList.type.shortLabel' | translate }} </th>
                <td mat-cell *matCellDef="let licence">
                    <span [ngClass]="{
                        'test-licence': licence.licenceType.code === licenceType.test,
                        'bought-licence': licence.licenceType.code !== licenceType.test
                    }">
                        {{ licence.licenceType.text.shortLabel }}
                    </span>
                </td>
            </ng-container>

            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef> {{ 'users.licencesList.actions.shortLabel' | translate }} </th>
                <td mat-cell *matCellDef="let licence">
                    <button mat-icon-button class="action-button" color="accent"
                        [matTooltip]="'users.licencesList.edit.summary' | translate" (click)="onEdit(licence.code)">
                        <mat-icon aria-label="Edit">edit</mat-icon>
                    </button>
                </td>
            </ng-container>

            <ng-container matColumnDef="paginator">
                <td mat-footer-cell *matFooterCellDef colspan="99">
                  <mat-paginator [pageSizeOptions]="[10,20,50]" showFirstLastButtons></mat-paginator>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            <!-- <tr mat-footer-row *matFooterRowDef="['paginator']"></tr> paginator is not used. Decomment for active. -->
        </table>
    </mat-card-content>
</mat-card>
